module.exports = __webpack_public_path__ + "static/media/ccs.88667c48.png";